import React, { useEffect, useState } from "react";
import '../../components/styles/FABRealTimeOrder.css'; // CSS 파일 임포트
import { API_BASE_URL_AGENT_DEV } from "../../services/apiConfig";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import { Modal, Button, Input, Table, Radio, InputNumber, Select } from 'antd'; // Ant Design 모달과 버튼 컴포넌트 임포트
import { useRecoilState } from "recoil";
import { MemberIdSave, ClubSeqSave, TokenSave } from '../../atom/user.atom';

const { Option } = Select;
interface FABRealTimeOrderProps {


}
interface MenuItem {
    name: string;
    price: number;
    count: number; // 메뉴 수량 추가
}

const FABRealTimeOrder: React.FC<FABRealTimeOrderProps> = ({ }) => {
    const [expandedIndices, setExpandedIndices] = useState<number[]>([]);
    const [stompClient, setStompClient] = useState<Stomp.Client | null>(null);
    const [transactions, setTransactions] = useState<any[]>([]);
    const [selectedOrder, setSelectedOrder] = useState<{ orderIndex: number; itemIndex: number; } | null>(null);
    const [showOrderModal, setShowOrderModal] = useState<boolean>(false);

    const [showOrderDeleteModal, setShowOrderDeleteModal] = useState<boolean>(false);

    const [showOnBehalfOfModal, setShowOnBehalfOfModal] = useState<boolean>(false);
    const [showMenuSelectModal, setShowMenuSelectModal] = useState<boolean>(false);
    const [selectedOrderDetails, setSelectedOrderDetails] = useState<any>(null);
    const [fnborderseq, setFnbOrderseq] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [tablenumber, setTablenumber] = useState<number>(1);
    const [consumerClubSeq, setConsumerClubSeq] = useState<number>(0);
    const [consumerDid, setConsumerDid] = useState<string>('');
    const [fnbContractSeq, setFnbContractSeq] = useState<number>(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [selectedRowKey, setSelectedRowKey] = useState<string | null>(null);
    const [tableData, setTableData] = useState<{ key: string; companyInfo: string; clubSeq: number; consumerDid: string; fnbContractSeq: number }[]>([]);
    const [selectedMenu, setSelectedMenu] = useState('');
    const [menutableData1, setMenutableData1] = useState<MenuItem[]>([]);

    const [selectedReason, setSelectedReason] = useState('재료 소진'); // 선택된 취소사유
    const [otherReason, setOtherReason] = useState(''); // 기타 사유 입력 값

    const [quantity, setQuantity] = useState<{ [key: string]: number }>({});

    const [clubSeqSave, setClubSeqSave] = useRecoilState(ClubSeqSave);
    const [memberIdSave, setmemberIdSave] = useRecoilState(MemberIdSave);
    const [tokenSave, setTokenSave] = useRecoilState(TokenSave);


    useEffect(() => {
        console.log("1:", clubSeqSave);
        console.log("2:", memberIdSave);
        console.log("3:", tokenSave);
    }, []);
    const handleSearch = async () => {
        console.log("전화번호 검색:", phoneNumber);

        try {
            const response = await fetch(
                `${API_BASE_URL_AGENT_DEV}/fnb/member/${clubSeqSave}/${phoneNumber}`,
                {
                    method: "GET",
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log("확인 ", data);

            // fnbContractList 유효성 검사를 추가
            const fnbContractList = data?.data?.fnbContractList;

            if (!Array.isArray(fnbContractList)) {
                console.warn("fnbContractList가 유효하지 않습니다:", fnbContractList);
                setTableData([]); // 데이터가 없을 경우 빈 배열로 설정
                return;
            }

            // API 응답 데이터로 테이블 데이터 업데이트
            const transformedData = fnbContractList.map((item: any) => ({
                key: item.fnbContractSeq.toString(), // fnbContractSeq를 key로 사용
                companyInfo: item.consumerClubName, // consumerClubName을 회사 정보로 사용
                clubSeq: Number(item.consumerClubSeq), // clubSeq를 숫자로 변환하여 사용
                fnbContractSeq: item.fnbContractSeq, // fnbContractSeq 추가
                consumerDid: data.data.did, // did 추가
            }));

            console.log("테이블데이터 :", transformedData);

            setTableData(transformedData); // 테이블 데이터 업데이트
        } catch (error) {
            console.error("전화번호 검색 중 에러:", error);
            setTableData([]); // 에러 발생 시 빈 배열로 설정
        }
    };

    const columns = [
        {
            title: "선택",
            dataIndex: "select",
            key: "select",
            render: (_: any, record: { key: string; clubSeq: number }) => (
                <Radio
                    checked={record.key === selectedRowKey}
                    onChange={() => {
                        setSelectedRowKey(record.key);  // 선택된 행의 key 저장
                        setConsumerClubSeq(record.clubSeq);  // 클릭된 회사의 clubSeq 저장
                    }}
                />
            ),
        },
        {
            title: "회사 정보",
            dataIndex: "companyInfo",
            key: "companyInfo",
        },
    ];
    const handleCountChange = async (index: number, operation: 'increase' | 'decrease', price: any) => {
        setMenutableData1(prevData => {
            const updatedData = [...prevData];
            const currentCount = updatedData[index].count;

            const updatedCount = isNaN(Number(currentCount)) ? 0 : Number(currentCount);

            if (operation === 'increase') {
                updatedData[index].count = updatedCount + 1;
            } else if (operation === 'decrease') {
                updatedData[index].count = Math.max(0, updatedCount - 1);
            }

            return updatedData;
        });
    };

    // useEffect로 menutableData1이 변경될 때마다 totalAmount 계산
    useEffect(() => {
        const totalAmount = menutableData1.reduce((sum, item) => sum + item.count * item.price, 0);
        setTotalAmount(totalAmount);

        const selectedItems = menutableData1
            .filter(item => item.count > 0)
            .map(item => ({ name: item.name, count: item.count, price: item.price }));

        setSelectedMenu(JSON.stringify({ order: selectedItems }));

        console.log("총합 가격:", totalAmount);
        console.log("선택한 메뉴:", selectedMenu);
    }, [menutableData1, selectedMenu]);




    const handleToggle = (orderIndex: number, itemIndex: number) => {
        const selectedTransaction = transactions[orderIndex];
        const selectedItem = selectedTransaction.orderedMenu.order[itemIndex];
        const fnborderseq = selectedTransaction.fnbOrderSeq;
        setFnbOrderseq(fnborderseq);
        setSelectedOrderDetails({
            tableNumber: selectedTransaction.tableNumber,
            companyName: selectedTransaction.consumerClubName,
            qrAuth: selectedTransaction.qrAuth,
            items: selectedTransaction.orderedMenu.order,
            totalPrice: selectedTransaction.totalPrice,
            consumerStatus: selectedTransaction.consumerStatus,
        });
        setShowOrderModal(true); // 모달 열기
        setSelectedOrder({ orderIndex, itemIndex });
    };

    useEffect(() => {
        fetchRealTimeOrderAPI();
    }, []);

    const fetchRealTimeOrderAPI = async () => {
        try {
            const today = new Date().toISOString().split('T')[0];
            const response = await fetch(
                `${API_BASE_URL_AGENT_DEV}/fnb/club/order/${clubSeqSave}/${today}/false?page=0&size=100000&sort=fnbOrderSeq,desc`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await response.json();

            // canceled가 false인 항목만 필터링
            const filteredData = (data.data.content || []).filter((item: { canceled: any }) => !item.canceled);


            console.log("확인 (필터링된 데이터):", filteredData);
            console.log("확인 ", data.data.content)
            setTransactions(filteredData || []);
        } catch (error) {
            console.error("(ExcelUpload) Error fetching data:", error);
        }
    };
    const playNotificationSound = () => {
        const audio = new Audio('/asset/sounds/bell.mp3'); // 알림 소리 경로
        audio.play().catch((error) => console.error("소리 재생 오류:", error));
    };

    useEffect(() => {

        try {
            if (!stompClient || !stompClient.connected) {
                const socket = new SockJS(API_BASE_URL_AGENT_DEV + "/ws");
                var stomp = Stomp.over(socket);

                const headers = { 'sender': MemberIdSave, 'type': 'waiting' };
                stomp.connect(
                    headers,
                    function () {
                        stomp.subscribe(`/queue/waiting-message/${memberIdSave}`, (message: any) => {
                            playNotificationSound();
                            fetchRealTimeOrderAPI();
                        });
                        setStompClient(stomp);
                    },
                    (error: any) => {
                        console.error("Error during WebSocket connection:", error);
                    }
                );
                stomp.ws.onclose = () => {
                    setStompClient(null);
                };
            }
        } catch (error) {
            alert("소켓에러 ");
        }
        return () => {
            if (stompClient) {
                stompClient.disconnect(() => {
                    console.log("WebSocket 연결이 해제되었습니다.");
                });
            }
        };
    }, []);

    const handleOnBehalfOf = () => {
        setShowOnBehalfOfModal(!showOnBehalfOfModal)
    }
    const handleOnBehalfOfOrderComplete = async () => {


        const requestBody: {
            providerClubSeq: number;
            consumerClubSeq: number;
            fnbContractSeq: number;
            orderedMenu: string;
            totalPrice: number;
            tableNumber: number;
            consumerDid: string;
            delegatedOrder: boolean;
            addConsumerList: any;

        } = {
            providerClubSeq: clubSeqSave || 0,
            consumerClubSeq: consumerClubSeq || 0,
            fnbContractSeq: fnbContractSeq,
            orderedMenu: selectedMenu,
            totalPrice: totalAmount,
            tableNumber: tablenumber,
            consumerDid: consumerDid,
            delegatedOrder: true,
            addConsumerList: [consumerDid]
        };
        console.log("최종 보내는데이터", requestBody)
        if (tablenumber !== 0) {
            const response = await fetch(
                `${API_BASE_URL_AGENT_DEV}/fnb/orders`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                }
            );
            console.log("변경사항 : " + JSON.stringify(requestBody));
            const data = await response.json();
            if (response.ok) {
                console.log("data2 : " + JSON.stringify(data, null, 2));

            }
            setShowOrderModal(false);
            setShowMenuSelectModal(false);
            setShowOnBehalfOfModal(false);
            setSelectedOrder(null);
            setPhoneNumber('')
            setTableData([])
            setSelectedRowKey('');
            setConsumerClubSeq(0);  // 클릭한 회사의 clubSeq 값을 저장
            setConsumerDid('');
            setFnbContractSeq(0)
        }


    }
    const handleOnBehalfOfselect = async () => {
        setShowOnBehalfOfModal(false);
        setShowMenuSelectModal(true);

        try {
            const response = await fetch(
                `${API_BASE_URL_AGENT_DEV}/fnb/club/menus/${clubSeqSave}/${consumerClubSeq}`,
                {
                    method: "GET",
                }
            );

            const data = await response.json();
            console.log("메뉴가공전", data.data.menu);

            const menuString = data.data.menu;
            const parsedData = JSON.parse(menuString).menu;
            const updatedData = parsedData.map((item: MenuItem) => ({
                ...item,
                count: 0, // count 값을 1로 설정
            }));

            setMenutableData1(updatedData); // 상태 업데이트

        } catch (error) {
            console.error("(ExcelUpload) Error fetching data:", error);
        }
    };

    const handleOrderDeleteModal = () => {
        setShowOrderDeleteModal(true)
    };
    const handleOrderDelete = () => {
        if (selectedReason === "기타") {
            console.log("취소사유 : " + otherReason);
        } else {
            console.log("취소사유 : " + selectedReason);
        }

        let canceledreason = null;
        if (selectedReason === "기타") {
            canceledreason = 0;
        } else if (selectedReason === "재료 소진") {
            canceledreason = 1;
        } else if (selectedReason === "주방 기기 고장") {
            canceledreason = 2;
        } else if (selectedReason === "더이상 판매하지 않음") {
            canceledreason = 3;
        } else if (selectedReason === "기간(한정) 메뉴") {
            canceledreason = 4;
        } else if (selectedReason === "손님 요청") {
            canceledreason = 5;
        }


        const postData = {
            canceledReason: canceledreason,
        };




        fetch(`${API_BASE_URL_AGENT_DEV}/fnb/orders/` + fnborderseq + `?canceledReason=${canceledreason}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenSave}`,
                body: JSON.stringify(postData)
            },
        })
            .then((response) => {
                if (!response.ok) {


                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json();
            })
            .then((data) => {
                console.log('Success:', data);
                setShowOrderDeleteModal(false)
                setShowMenuSelectModal(false)

            })
            .catch((error) => {
                console.error('Error:', error);
            });





    };

    const handleOrderComplete = () => {
        setShowOrderModal(false);
        const patchData = {
            fnbOrderSeq: fnborderseq,
            providerOrderChecked: true,
        };
        fetch(`${API_BASE_URL_AGENT_DEV}/fnb/provider/order/check`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(patchData),
        })
            .then(response => response.json())
            .then(data => {
                fetchRealTimeOrderAPI();
            })
            .catch(error => {
                console.error('There was an error with the PATCH request:', error);
            });
    };
    const onRowClick = (record: any) => {
        setSelectedRowKey(record.key); // 클릭한 행의 key 값을 상태로 저장
    };
    const today = new Date().toLocaleDateString();
    const handleReasonChange = (e: any) => {
        setSelectedReason(e.target.value);
        if (e.target.value !== '기타') {
            setOtherReason(''); // 기타가 아닐 경우 다른 입력값 초기화
        }
    };

    return (
        <div className="layout">
            <h3>
                {today}
            </h3>

            <div className="main-content-realtimeorder">
                <table className="order-table">
                    <thead>
                        <tr>
                            <th>테이블 번호</th>
                            <th>시간</th>
                            <th>회사명</th>
                            <th>메뉴</th>
                            <th>수량</th>
                            <th>가격</th>
                            <th>상태</th>
                            <th>결제 상태</th>
                        </tr>
                    </thead>
                    <tbody>
                        {transactions.map((transaction, orderIndex) => (
                            transaction.orderedMenu?.order?.map((item: any, itemIndex: number) => (
                                <tr
                                    key={`${orderIndex}-${itemIndex}`}
                                    className={selectedOrder?.orderIndex === orderIndex && selectedOrder.itemIndex === itemIndex ? 'selected' : ''}
                                    onClick={() => handleToggle(orderIndex, itemIndex)}
                                >
                                    <td>{transaction.tableNumber === 0 ? "포장" : transaction.tableNumber}</td>
                                    <td>{new Date(transaction.created).toLocaleString()}</td> {/* 날짜/시간 형식으로 표시 */}
                                    <td>{transaction.consumerClubName}</td>
                                    <td>{item.name}</td>
                                    <td>{item.count}</td>
                                    <td>{item.count * parseInt(item.price)}</td>
                                    <td>{item.served ? "서빙 완료" : "대기 중"}</td>
                                    <td>{transaction.providerChecked ? "결제 완료" : "미결제"}</td>
                                </tr>
                            ))
                        ))}
                    </tbody>
                </table>
            </div>


            <Modal
                title={`${selectedOrderDetails?.tableNumber}번 테이블 주문 내역`}
                visible={showOrderModal}
                onCancel={() => {
                    setShowOrderModal(false);
                    setSelectedOrder(null);
                }}
                footer={[
                    <Button key="delete" type="default" danger onClick={handleOrderDeleteModal}>
                        주문취소
                    </Button>,
                    <Button key="complete" type="primary" onClick={handleOrderComplete}>
                        주문완료
                    </Button>

                ]}
            >
                <p>회사명: {selectedOrderDetails?.companyName}</p>
                <ul>
                    {selectedOrderDetails?.consumerStatus?.map((status: any, index: number) => (
                        <li key={index}>{status.name} {status.checked ? "(체크)" : "(미체크)"}</li>
                    ))}
                </ul>
                <p>주문 메뉴:</p>
                <ul>
                    {selectedOrderDetails?.items?.map((item: any, index: number) => (
                        <li key={index}>{item.name} {item.count}개 {item.price}원</li>
                    ))}
                </ul>
                <p>총액: {selectedOrderDetails?.totalPrice}원</p>
            </Modal>


            <Modal
                title="대신 주문하기"
                visible={showOnBehalfOfModal}
                onCancel={() => {
                    setShowOnBehalfOfModal(false);
                    setSelectedOrder(null);
                    setPhoneNumber('')
                    setTableData([])
                    setSelectedRowKey('');
                    setConsumerClubSeq(0);  // 클릭한 회사의 clubSeq 값을 저장
                    setConsumerDid('');
                    setFnbContractSeq(0)
                }}
                footer={[
                    <Button key="complete" type="primary" onClick={handleOnBehalfOfselect}>
                        선택완료
                    </Button>
                ]}
            >
                <p>전화번호:</p>
                <Input
                    style={{ width: '60%', marginRight: '8px' }}
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    placeholder="전화번호 입력"
                />
                <Button onClick={handleSearch}>검색</Button>

                <Table
                    columns={columns}
                    dataSource={tableData}
                    pagination={false}
                    rowKey="key"
                    style={{ marginTop: '16px' }}
                    onRow={(record) => ({
                        onClick: () => {
                            setSelectedRowKey(record.key);
                            setConsumerClubSeq(record.clubSeq);  // 클릭한 회사의 clubSeq 값을 저장
                            setConsumerDid(record.consumerDid);
                            setFnbContractSeq(record.fnbContractSeq)
                            console.log("선택한 클럽의 시퀀스 : ", record.clubSeq)
                        },
                    })}
                />
            </Modal>
            <Modal
                title="주문 취소사유"
                visible={showOrderDeleteModal}
                onCancel={() => {
                    setShowOrderDeleteModal(false);
                    setSelectedReason('');
                    setOtherReason('');
                }}
                footer={[
                    <Button key="complete" type="primary" onClick={handleOrderDelete}>
                        취소하기
                    </Button>
                ]}
            >
                <Radio.Group
                    value={selectedReason}
                    onChange={handleReasonChange}
                    style={{ width: '100%' }}
                >
                    <Radio style={{ display: 'block', textAlign: 'left' }} value="재료 소진">재료 소진</Radio>
                    <Radio style={{ display: 'block', textAlign: 'left' }} value="주방 기기 고장">주방 기기 고장</Radio>
                    <Radio style={{ display: 'block', textAlign: 'left' }} value="더이상 판매하지 않음">더이상 판매하지 않음</Radio>
                    <Radio style={{ display: 'block', textAlign: 'left' }} value="기간(한정) 메뉴">기간(한정) 메뉴</Radio>
                    <Radio style={{ display: 'block', textAlign: 'left' }} value="손님 요청">손님 요청</Radio>
                    <Radio style={{ display: 'block', textAlign: 'left' }} value="기타">기타</Radio>
                </Radio.Group>

                {/* {selectedReason === '기타' && (
                    <Input
                        value={otherReason}
                        onChange={(e) => setOtherReason(e.target.value)}
                        placeholder="기타 사유를 입력하세요"
                        style={{ marginTop: 10 }}
                    />
                )} */}
            </Modal>
            <Modal
                title="메뉴 선택"
                visible={showMenuSelectModal}
                onCancel={() => {
                    setShowOrderModal(false);
                    setShowMenuSelectModal(false);
                    setSelectedOrder(null);
                }}
                footer={[
                    <Button key="complete" type="primary" onClick={handleOnBehalfOfOrderComplete}>
                        선택완료
                    </Button>
                ]}
            >
                주문하실 메뉴와 수량을 선택해주세요.
                <div>
                    <a>테이블번호:  </a>
                    <Input
                        style={{ width: '60%', marginRight: '8px' }}
                        value={tablenumber}
                        onChange={(e) => setTablenumber(Number(e.target.value))}
                        placeholder="테이블번호 입력"
                    />
                </div>
                <div>
                    <p>메뉴</p>
                    {menutableData1.length > 0 ? (
                        menutableData1.map((item, index) => (
                            <div key={index} style={{ marginBottom: "10px" }}>
                                <span>{item.name} ({item.price}원) </span>
                                <span style={{ marginLeft: "10px" }}>
                                    <button onClick={() => handleCountChange(index, 'decrease', item.price)}> - </button>
                                    <span style={{ margin: "0 10px" }}>{item.count}</span>
                                    <button onClick={() => handleCountChange(index, 'increase', item.price)}> + </button>
                                </span>
                            </div>
                        ))
                    ) : (
                        <p>메뉴를 불러오는 중입니다...</p>
                    )}

                    <p>총합: {totalAmount}원</p>  {/* 총합 가격 표시 */}
                </div>


            </Modal>
            <button
                className="OnBehalfOf-button"
                onClick={() => handleOnBehalfOf()} // 클릭 시 호출할 함수
            >
                대신주문하기
            </button>
        </div>
    );
};

export default FABRealTimeOrder;
